import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import {
  checkStatus,
  clearStatus,
  generateToken,
  userLogin,
} from "../../redux/slices/auth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const LoginForm = props => {
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState(0);
  const [localErrors, setLocalErrors] = useState({});
  const { loginType } = props;
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const {
    loginStatus,
    randomNumber,
    transactionId,
    loginError,
    tokenerror,
    token,
    tokenStatus,
    checkStatusValue,
    loginErrorCode,
  } = auth;
  function isNumeric(num) {
    return !isNaN(num);
  }

  const regCitizen = /^(?=\d{10}$)(1)/;
  const regResident = /^(?=\d{10}$)(2)/;
  const regBorderNo = /^(?=\d{10}$)(3|4|5|6)/;

  function handleUserIdChange(e) {
    setUserId(e.target.value);
  }

  function userIdValidation(currentUserId) {
    if (currentUserId.length <= 0) {
      if (loginType === "NON_RESIDENT") {
        setLocalErrors(errors => ({
          ...errors,
          userId: "حقل رقم الحدود مطلوب",
        }));
      } else if (
        loginType === "CITIZEN" ||
        loginType === "LEGAL_REPRSENTATIVE" ||
        loginType === "LEGAL_AGENT"
      ) {
        setLocalErrors(errors => ({
          ...errors,
          userId: "حقل رقم الهوية / الإقامة مطلوب",
        }));
      }
    } else if (!isNumeric(currentUserId)) {
      if (loginType === "NON_RESIDENT") {
        setLocalErrors(errors => ({
          ...errors,
          userId: "رقم الحدود يجب أن يكون أرقام فقط",
        }));
      } else if (
        loginType === "CITIZEN" ||
        loginType === "LEGAL_REPRSENTATIVE" ||
        loginType === "LEGAL_AGENT"
      ) {
        setLocalErrors(errors => ({
          ...errors,
          userId: "رقم الهوية / الإقامة يجب أن يكون أرقام فقط",
        }));
      }
    } else if (isNumeric(currentUserId)) {
      if (
        loginType === "CITIZEN" ||
        loginType === "LEGAL_REPRSENTATIVE" ||
        loginType === "LEGAL_AGENT"
      ) {
        if (regCitizen.test(userId) || regResident.test(userId)) {
          setLocalErrors(errors => ({
            ...errors,
            userId: undefined,
          }));
        } else {
          setLocalErrors(errors => ({
            ...errors,
            userId: "الرقم يجب أن يبدأ ب 1 أو 2 وأن يكون 10 ارقام",
          }));
        }
      } else if (loginType === "NON_RESIDENT") {
        if (regBorderNo.test(userId)) {
          setLocalErrors(errors => ({
            ...errors,
            userId: undefined,
          }));
        } else {
          setLocalErrors(errors => ({
            ...errors,
            userId: "الرقم يجب أن يبدأ ب 3، 4، 5 أو 6 وأن يكون 10 ارقام",
          }));
        }
      }
    } else {
      setLocalErrors(errors => ({
        ...errors,
        userId: undefined,
      }));
    }
  }

  function handleUserIdBlur(e) {
    userIdValidation(e.target.value);
  }

  const toggleModal = () => {
    setShow(prevState => !prevState);
  };

  useEffect(() => {
    if (randomNumber && transactionId && loginStatus === "success") {
      toggleModal();
      dispatch(clearStatus());
      dispatch(checkStatus({ id: userId, randomNumber, transactionId }));
    }
  }, [randomNumber, transactionId, loginStatus, userId, dispatch]);

  useEffect(() => {
    if (checkStatusValue === "WAITING") {
      setTimeout(() => {
        dispatch(checkStatus({ id: userId, randomNumber, transactionId }));
      }, 5000);
    } else if (checkStatusValue === "EXPIRED") {
      toggleModal();
      navigate(`/?message="Authentication Faild"`);
    } else if (checkStatusValue === "COMPLETED") {
      dispatch(clearStatus());
      dispatch(generateToken({ id: userId, randomNumber, transactionId }));
    }
  }, [
    randomNumber,
    transactionId,
    userId,
    dispatch,
    checkStatusValue,
    navigate,
  ]);

  useEffect(() => {
    if (tokenStatus === "success" && token) {
      dispatch(clearStatus());
      navigate("/mashup");
    }
  }, [token, tokenStatus, dispatch, navigate]);

  useEffect(() => {
    if (tokenerror) {
      toggleModal();
    }
  }, [tokenerror]);

  const onSubmit = e => {
    e.preventDefault();
    setLocalErrors({});
    let userType = "";

    if (loginType === "CITIZEN" && userId > 0 && regCitizen.test(userId)) {
      userType = "CITIZEN";
    } else if (
      loginType === "CITIZEN" &&
      userId > 0 &&
      regResident.test(userId)
    ) {
      userType = "RESIDENT";
    } else {
      userType = loginType;
    }
    if (isNumeric(userId) && userId > 0 && !localErrors.userId) {
      dispatch(userLogin({ id: userId, userType }));
    } else {
      userIdValidation(userId);
    }
  };
  return (
    <>
      <Modal show={show} centered>
        <Modal.Body className="auth-code">
          <h3 className="text-center">
            الرجاء إدخال رمز التوثيق في تطبيق نفاذ
          </h3>
          <h1 className="text-center">{randomNumber}</h1>
        </Modal.Body>
      </Modal>

      <Form onSubmit={onSubmit}>
        <Form.Group className="mb-3 w-100" controlId="userName">
          <Form.Label>
            {loginType && loginType === "NON_RESIDENT" ? (
              <span>رقم الحدود</span>
            ) : loginType &&
              (loginType === "RESIDENT" ||
                loginType === "CITIZEN" ||
                loginType === "LEGAL_REPRSENTATIVE" ||
                loginType === "LEGAL_AGENT") ? (
              <span>رقم الهوية / الإقامة</span>
            ) : loginType && loginType === "LEGAL_REPRSENTATIVE" ? (
              <span>رقم الحدود</span>
            ) : (
              <span>رقم الهوية / الإقامة</span>
            )}

            <span className="required">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder=""
            onChange={handleUserIdChange}
            onBlur={handleUserIdBlur}
            isInvalid={
              localErrors?.userId || loginError || tokenerror ? true : false
            }
          />
          {localErrors?.userId ? (
            <Form.Control.Feedback type="invalid">
              {localErrors.userId}
            </Form.Control.Feedback>
          ) : null}
          {loginError && loginErrorCode === "E600608" ? (
            <Form.Control.Feedback type="invalid">
              فشل تسجيل الدخول يرجى المحاولة بعد دقيقة واحدة على الأقل
            </Form.Control.Feedback>
          ) : loginError ? (
            <Form.Control.Feedback type="invalid">
              فشل تسجيل الدخول
            </Form.Control.Feedback>
          ) : null}
          {tokenerror ? (
            <Form.Control.Feedback type="invalid">
              {tokenerror}
            </Form.Control.Feedback>
          ) : null}
        </Form.Group>

        {loginStatus === "pending" ? (
          <Button variant="primary">
            <Spinner animation="border" role="status" size="sm">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Button>
        ) : (
          <Button variant="primary" type="submit">
            تسجيل الدخول
          </Button>
        )}
      </Form>
    </>
  );
};
